import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { IdentityProviderLoginComponent } from 'ish-shared/components/login/identity-provider-login/identity-provider-login.component';
import { Auth0SignInComponent } from '../auth0-sign-in/auth0-sign-in.component';
import { AzureSignInComponent } from '../azure-sign-in/azure-sign-in.component';

@Component({
  selector: 'ish-login-modal',
  templateUrl: './login-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IdentityProviderLoginComponent,
    ServerHtmlDirective,
    TranslateModule,
    Auth0SignInComponent,
    AzureSignInComponent,
  ],
})
export class LoginModalComponent {
  private cdRef = inject(ChangeDetectorRef);

  @Input() loginMessageKey: string;
  @Output() closeModal = new EventEmitter<void>();
  isModal = true;

  // not-dead-code
  detectChanges() {
    this.cdRef.detectChanges();
  }

  hide() {
    this.closeModal.emit();
  }
}
